<template>
  <div class="wrapper">
    <div class="search">
      <div class="search__back iconfont" @click="handleBackClick">&#xe679;</div>
      <div class="search__content">
        <span class="search__content__icon iconfont" @click="handleSearchClick"
          >&#xe741;</span
        >
        <input
          class="search__content__input"
          placeholder="搜索我的订单"
          v-model="currentSearchText"
          @keyup.enter="handleSearchClick"
        />
      </div>
    </div>
    <div class="orders" id="scroll">
      <nut-infiniteloading
        containerId="scroll"
        :use-window="false"
        :has-more="hasMore"
        :load-icon="loadingIcon"
        @load-more="loadMore"
      >
        <div
          class="order"
          v-for="(item, index) in list"
          :key="index"
          @click="toOrderInfoClick(item.orderNum)"
        >
          <div class="order__title">
            订单编号: {{ item.orderNum }}
            <span class="order__status">
              {{ item.status }}
            </span>
          </div>
          <div class="order__content">
            <div class="order__content__imgs">
              <template
                v-for="(innerItem, innerIndex) in item.products"
                :key="innerIndex"
              >
                <img
                  class="order__content__img"
                  :src="innerItem.goodsImg"
                  v-if="innerIndex <= 3"
                />
              </template>
            </div>
            <div class="order__content__info">
              <div class="order__content__price">
                ¥ {{ item.payAmount.toFixed(2) }}
              </div>
              <div class="order__content__count">
                共 {{ item.totalNumber }} 件
              </div>
            </div>
          </div>
        </div>
      </nut-infiniteloading>
    </div>
  </div>
  <Docker :currentIndex="2" dockerName="OrderList" />
</template>

<script setup>
import { reactive, toRefs, ref } from 'vue'
import store from '@/store'
import { PAGESIZE } from '@/constant'
import { useRouter } from 'vue-router'
import { getOrder } from '@/api'
import Docker from '@/components/Docker'

// 分页变量定义
let pageNum = 1
const totalPage = ref(0)
const hasMore = ref(true)
const loadingIcon = ref('/images/loading.png')
// 处理订单列表逻辑
const currentSearchText = ref('')
const data = reactive({ list: [] })
// 获取订单信息
const getOrderList = async () => {
  const result = await getOrder({
    userId: store.getters.userInfo.id,
    goodsName: currentSearchText.value,
    status: '',
    page: pageNum,
    pageSize: PAGESIZE
  })
  if (result) {
    const orderList = result.orderList
    orderList.forEach((order) => {
      const products = order.products || []
      const totalPrice = 0
      let totalNumber = 0
      products.forEach((productItem) => {
        totalNumber += productItem?.orderSales || 0
      })
      order.totalPrice = totalPrice
      order.totalNumber = totalNumber
    })
    for (const iterator of result.orderList) {
      data.list.push(iterator)
    }
    // 只返回一页时能正确显示
    if (totalPage.value === 1) {
      hasMore.value = false
    }
  }
  totalPage.value = result.totalPages
}
getOrderList()
const { list } = toRefs(data)
const loadMore = (done) => {
  pageNum++
  setTimeout(() => {
    getOrderList()
    if (pageNum >= totalPage.value) {
      hasMore.value = false
    }
    done()
  }, 500)
}

// 搜索
const handleSearchClick = () => {
  pageNum = 1
  hasMore.value = true
  data.list.splice(0)
  getOrderList()
}

// 详细
const toOrderInfoClick = (orderNum) => {
  router.push(`/orderInfo/${orderNum}`)
}

// 返回
const router = useRouter()
const handleBackClick = () => {
  router.push('/')
}
</script>

<style lang="scss" scoped>
@import '@/style/viriables.scss';
.wrapper {
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0.5rem;
  right: 0;
  background: rgb(248, 248, 248);
  padding: 0 0.18rem;
}
.search {
  display: flex;
  margin: 0.14rem 0 0.04rem 0;
  line-height: 0.32rem;
  &__back {
    width: 0.3rem;
    font-size: 0.24rem;
    color: #b6b6b6;
  }
  &__content {
    display: flex;
    flex: 1;
    background: $bgColor;
    border-radius: 0.16rem;
    &__icon {
      width: 0.44rem;
      text-align: center;
      color: $search-fontColor;
    }
    &__input {
      display: block;
      width: 100%;
      padding-right: 0.2rem;
      border: none;
      outline: none;
      background: none;
      height: 0.32rem;
      font-size: 0.14rem;
      color: $content-fontcolor;
      &::placeholder {
        color: $content-notice-fontcolor;
      }
    }
  }
}
.orders {
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 0.5rem;
  bottom: 0rem;
  right: 0;
}
.order {
  margin: 0.16rem 0;
  padding: 0.16rem;
  background: $bgColor;
  &__title {
    margin-bottom: 0.16rem;
    line-height: 0.22rem;
    font-size: 0.14rem;
    color: $medium-fontColor;
  }
  &__status {
    float: right;
    font-size: 0.14rem;
    color: $light-fontColor;
  }
  &__content {
    display: flex;
    &__imgs {
      flex: 1;
    }
    &__img {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.12rem;
    }
    &__info {
      width: 0.7rem;
    }
    &__price {
      margin-bottom: 0.04rem;
      line-height: 0.2rem;
      font-size: 0.14rem;
      color: $hightlight-fontColor;
      text-align: right;
    }
    &__count {
      line-height: 0.14rem;
      font-size: 0.12rem;
      color: $content-fontcolor;
      text-align: right;
    }
  }
}
</style>
